import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Button,
  Label,
  makeStyles,
  tokens,
  useToastController,
  useId,
  Toaster,
} from "@fluentui/react-components";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import CaseNavList from "../CaseNavList";
import CaseForm from "../CaseForm";
import CaseList from "../CaseList";
import ContentLoader from "../../../../components/Loader/ContentLoader";
import ModalDialog from "../../../../components/ModalDialog";
import CaseDetailDrawer from "../CaseDetailDrawer";
import {
  getLiabilityDetailById,
  getLiabilityPaymentDetailById,
  getLiabilityPaymentsListItems,
} from "../../../../redux/Case/liabilitySlice";
import { useToastMessage } from "../../../../components/ToastMessage/ToastMessage";
import NoDataFound from "../../../../components/NoDataFound/noDataFound";

const useStyles = makeStyles({});

function LiabilityPayments({ tab }: { tab: string }) {
  const navigate = useNavigate();
  const styles = useStyles();
  const { showToast, toasterId } = useToastMessage();
  const { clientId, case_type, action, caseId, subItemId } = useParams();
  const dispatch: AppDispatch = useDispatch();
  const [currentRecord, setCurrentRecord] = useState(1);

  const formSettingsObj = useSelector((state: RootState) => state.formSettings);
  const liabilities = useSelector((state: RootState) => state.liabilities);
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);

  const caseType = case_type || "";
  const [isOpen, setIsOpen] = useState(false);
  const handleDetailPopup = (action: boolean) => {
    setIsOpen(action);
  };
  useEffect(() => {
    if (caseId && clientId) {
      dispatch(getLiabilityDetailById({ id: caseId, customerId: clientId }));
      dispatch(
        getLiabilityPaymentsListItems({ id: caseId, customerId: clientId })
      );
    }
  }, [caseId, clientId, dispatch]);

  const paymentId =
    subItemId || liabilities.payments.listItems[0]?.payment.payment_id;

  useEffect(() => {
    if (!caseId || !paymentId) return;
    if (action === "view") {
      navigate(
        `/clients/${clientId}/liabilities/${case_type}/${caseId}/payments/${paymentId}/${
          tab || "payment"
        }/view`
      );
    } else if (action === "add") {
      navigate(`/clients/${clientId}/liabilities/${case_type}/${caseId}/payment/add`);
    } else if (action === "edit") {
      navigate(
        `/clients/${clientId}/liabilities/${case_type}/${caseId}/payments/${paymentId}/${
          tab || "payment"
        }/edit`
      );
    } else {
      navigate(
        `/clients/${clientId}/liabilities/${case_type}/${caseId}/payments/${paymentId}/${
          tab || "payment"
        }/view`
      );
    }
  }, [
    action,
    clientId,
    case_type,
    liabilities.payments.listItems,
    caseId,
    paymentId,
    tab,
    navigate,
  ]);

  useEffect(() => {
    if (subItemId) {
      dispatch(getLiabilityPaymentDetailById(subItemId));
    }
  }, [subItemId, dispatch, liabilities.payments.listItems]);

  return (
    <div>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />

      <CaseNavList
        subItem="payments"
        section="liabilities"
        tab={tab}
        caseType={caseType}
        caseDetail={liabilities?.payments.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <div className="case_container_flex">
        <CaseForm
          mode={action || ""}
          section="liabilities"
          caseType={caseType}
          caseDetail={liabilities?.payments.activeItem}
          caseItemList={liabilities?.payments.listItems}
          tab={tab}
          subItem="payments"
          paymentValue={liabilities?.payments.totalPayment}
          notify={showToast}
          currentRecord={currentRecord}
          setCurrentRecord={setCurrentRecord}
        />
        <div>
          {liabilities?.payments.listLoading ? (
            <ContentLoader />
          ) : (
            <>
              {liabilities?.payments.listItems.length > 0 && (
                <CaseList
                  module="payments"
                  data={liabilities?.payments.listItems}
                  activeItem={liabilities?.payments.activeItem}
                  section="liabilities"
                  activeTab={tab}
                  currentRecord={currentRecord}
                  setCurrentRecord={setCurrentRecord}
                />
              )}
              {!action && liabilities?.payments.listItems.length === 0 && (
                <NoDataFound />
              )}
            </>
          )}
        </div>
      </div>
      <CaseDetailDrawer
        isOpen={isOpen}
        caseDetail={liabilities?.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <ModalDialog options={dialogModalOptions} />
    </div>
  );
}

export default LiabilityPayments;
